export default __webpack_public_path__ + "static/media/file-upload.3fe48a2e.svg";